export default "__VITE_ASSET__b3e0291c__"